import ModalComponent from 'src/components/Modal/ModalComponent';
import { Stack, TextField, Typography, useTheme } from '@mui/material';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
interface IProps {
  open: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
  isLoading?: boolean;
  value: string;
  onChange: (value: string) => void;
}
const FormBookmarkNote = (props: IProps) => {
  const { open, handleClose, handleSubmit, isLoading, value, onChange } = props;

  const theme = useTheme();

  return (
    <ModalComponent padding={4} handleClose={handleClose} open={open} onClick={(e) => e.stopPropagation()}>
      <Stack flexDirection={'column'} gap={2}>
        <Stack>
          <Typography textAlign={'center'} variant="h5">
            Bookmark & Note
          </Typography>
          <Typography textAlign={'center'} color={theme.palette.text.secondary} variant="body1">
            Add notes to your bookmarks for easier recall and better organization.
          </Typography>
        </Stack>

        <TextField
          value={value}
          onChange={(e) => onChange(e.target.value)}
          sx={{ mt: 2 }}
          id="outlined-multiline-static"
          label="Note"
          multiline
          rows={4}
          placeholder={'Enter your note'}
        />
        <ButtonWithLoading
          color={'primary'}
          variant={'contained'}
          isLoading={isLoading}
          onClick={() => handleSubmit()}
          disabled={isLoading}
        >
          Save Note
        </ButtonWithLoading>
      </Stack>
    </ModalComponent>
  );
};

export default FormBookmarkNote;
